module.exports = __webpack_public_path__ + "static/media/car-wrap-color.380aa3f8.png";